import { apiClient } from '@/plugins/axios'

export default {
  getMe(token) {
    return apiClient().get('/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  },
}
